import { Component, OnInit } from '@angular/core';

import { NucleoService } from './shared/nucleo.service'
import { Nucleo, NucleoPage } from './shared/types'
import { environment } from '../../../environments/environment'

@Component({
  selector: 'app-nucleo',
  templateUrl: './nucleo.component.html',
  styleUrls: ['./nucleo.component.scss']
})
export class NucleoComponent implements OnInit {
  nucleos: Nucleo[]
  informationsPage: NucleoPage
  loading: boolean = true
  universidade: string = environment.loginContexto
  year = new Date().getFullYear()

  constructor(
    private nucleoService: NucleoService
  ) { }

  ngOnInit() {
    this.getNucleos()
    this.getInformationsPage()
    this.loading = false
  }

  getInformationsPage() {
    this.nucleoService.getInformationsPage().then((informations: NucleoPage) => {
      this.informationsPage = informations
    })
  }

  getNucleos() {
    this.nucleoService.getNucleos().then((nucleos: Nucleo[]) => {
      this.nucleos = nucleos

      this.defineSrcImg(nucleos)
    })
  }

  defineSrcImg(nucleos: Nucleo[]) {
    this.loading = true
    nucleos.map((nucleo) => {
      const url = this.getMedia(nucleo).then(url => {
        nucleo.srcImg = url
      })
    })

    this.loading = false
  }

  async getMedia(nucleo: Nucleo) {
    const path = nucleo._links['wp:featuredmedia'][0].href

    const href = await this.nucleoService.getImage(path).then((link) => {
      return link
    })

    return href
  }

}
